import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'campaign-step-audience' }

import { computed, type PropType } from 'vue'
import ToggleField from '@/components/PaymentPages/ToggleField.vue'
import CustomerFilterPanel from '@/components/CustomerFilterPanel.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 'one_time' sends once; 'ongoing' checks a daily condition (set on the
  // Schedule step, merged onto the filter by the editor) and sends every day.
  campaignType: { type: String, default: 'one_time' },
  endsOn: { type: String, default: '' }, // yyyy-MM-dd, ongoing only; shapes the count label
  conditionDays: { type: Number, default: 7 }, // ongoing only; shapes the count label
  conditionType: { type: String as PropType<string>, default: 'birthday_in_days' }, // ongoing only
  lapseDays: { type: Number as PropType<number | undefined>, default: undefined }, // ongoing only; visit condition
  audienceMode: { type: String, default: 'new' },
  audienceFilter: { type: Object as PropType<Record<string, any>>, default: () => ({}) },
  savedAudienceId: { type: Number as PropType<number | null>, default: null },
  audiences: { type: Array as PropType<any[]>, default: () => [] },
  games: { type: Array as PropType<any[]>, default: () => [] },
  previewCount: { type: Number as PropType<number | null>, default: null },
  previewSample: { type: Array as PropType<any[]>, default: () => [] },
  previewLoading: { type: Boolean, default: false },
  previewError: { type: String, default: '' },
  hygiene: { type: Object as PropType<{ suppressed_total: number; reasons: Record<string, number>; unchecked_domains?: number } | null>, default: null },
  domainChecking: { type: Boolean, default: false },
  estimatedCost: { type: String, default: '' },
  saveAudience: { type: Boolean, default: false },
  audienceName: { type: String, default: '' },
  scopedGroupIds: { type: Array as PropType<number[] | null>, default: null }
},
  emits: [
  'update:audience-mode',
  'update:audience-filter',
  'update:saved-audience-id',
  'update:save-audience',
  'update:audience-name',
  'edit-audience',
  'delete-audience',
  'view-recipients',
  'check-domains'
],
  setup(__props) {

const props = __props





// Ongoing estimate wording: the count is the reach, not today's slice
const ongoingCountLabel = computed(() => {
  if (props.conditionType === 'days_since_last_visit') {
    const d = Number.isInteger(props.lapseDays) ? props.lapseDays : 0
    const when = `${d} ${d === 1 ? 'day' : 'days'}`
    if (props.endsOn) return `customers who have not visited in ${when}, or will not have by the stop date, will be emailed once, and again if they lapse after a new visit`
    return `customers who have not visited in ${when} will be emailed once, and again if they lapse after a new visit`
  }
  const days = Number.isInteger(props.conditionDays) ? props.conditionDays : 0
  const when = days === 0 ? 'on their birthday' : days === 1 ? '1 day before their birthday' : `${days} days before their birthday`
  if (props.endsOn) return `customers will be emailed ${when} before the stop date, one email each`
  return `customers with a birthday on file will be emailed ${when} over the coming year, one email each`
})

const selectedAudience = computed(() => props.audiences.find((a: any) => a.id === props.savedAudienceId) || null)

const hasFilters = computed(() => Object.keys(props.audienceFilter || {}).length > 0 || props.audienceMode === 'saved')

// Undeliverable breakdown, only the reasons with a count. Wording matches the
// reason labels on the campaign report.
const HYGIENE_LABELS: Record<string, string> = {
  suppressed_prior_bounce: 'previously bounced',
  suppressed_complaint: 'previously marked as spam',
  suppressed_invalid_address: 'invalid addresses',
  suppressed_disposable_domain: 'disposable addresses',
  suppressed_no_mx: 'on domains that cannot receive mail'
}
const hygieneBreakdown = computed(() => {
  const reasons = props.hygiene?.reasons || {}
  const parts: string[] = []
  for (const [code, label] of Object.entries(HYGIENE_LABELS)) {
    const n = reasons[code] || 0
    if (n > 0) parts.push(`${n.toLocaleString()} ${label}`)
  }
  return parts.join(', ')
})

// Dedupe the sample for display and never render a blank name: fall back to
// the email address when a customer record has no name on file.
const sampleNames = computed(() => {
  const seen = new Set<string>()
  const names: string[] = []
  for (const person of props.previewSample as any[]) {
    const display = `${person.first_name || ''} ${person.last_name || ''}`.trim() || person.email || ''
    if (!display || seen.has(display)) continue
    seen.add(display)
    names.push(display)
    if (names.length >= 5) break
  }
  return names
})

return { __sfc: true,props, ongoingCountLabel, selectedAudience, hasFilters, HYGIENE_LABELS, hygieneBreakdown, sampleNames, ToggleField, CustomerFilterPanel }
}

})